// Supported languages in Learner's App
export const supportedLanguages = [
  'ar',
  'bn',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fr',
  'fi',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sv',
  'ta',
  'th',
  'tr',
  'uk',
  'vi',
  'zh',
  'zh-tw'
] as const;
